// Module
var code = "<div id=\"V-2EEF8482-4D03-410A-960A-EE8014B4FD6C\"> <div data-b-component=\"checkbox\" data-b-comp-checked=\"{Binding Checked}\" data-b-attr-class=\"{Binding Class}\" data-b-attr-style=\"{Binding Style}\"></div> </div> ";
// Exports
export default code;